import React, { useCallback, useMemo } from 'react';

import { GeoSearchBoxCustom, CoordinateRetrieveResponse } from '@strava/ui/Map';
import I18n from 'utils/I18n';

import styles from './styles.scss';

interface GeoResult {
  city: string;
  state: string;
  country: string;
  lat_lng: [number, number];
}

interface LocationAutocompleteProps {
  value?: string;
  onGeoResult?: (result: GeoResult | null) => void;
  isScoutEnabled?: boolean;
}

function LocationAutocomplete({
  value = '',
  onGeoResult,
  isScoutEnabled = false
}: LocationAutocompleteProps) {
  const options = useMemo(
    () => ({
      language: I18n.language()
    }),
    []
  );

  const handleRetrieve = useCallback(
    (response: CoordinateRetrieveResponse) => {
      if (!response.features || response.features.length === 0) return;

      const feature = response.features[0];
      const properties = feature.properties || {};
      const coords = feature.geometry.coordinates; // [lng, lat]

      onGeoResult?.({
        city: properties.locality || '',
        state: properties.region || '',
        country: properties.country || '',
        lat_lng: [coords[1], coords[0]] // [lat, lng]
      });
    },
    [onGeoResult]
  );

  const handleChange = useCallback(() => {
    onGeoResult?.(null);
  }, [onGeoResult]);

  const handleClear = useCallback(() => {
    onGeoResult?.(null);
  }, [onGeoResult]);

  return (
    <div className={styles['location-autocomplete']}>
      <GeoSearchBoxCustom
        value={value}
        placeholder={I18n.t('strava.settings.location.placeholder')}
        options={options}
        onRetrieve={handleRetrieve}
        onChange={handleChange}
        onClear={handleClear}
        displaySearchIcon={false}
        displayClearButton={true}
        className={styles['search-box']}
        inputWrapperClassName={styles['input-wrapper']}
        resultsClassName={styles.results}
        isLoggedIn={true}
        isScoutEnabled={isScoutEnabled}
      />
    </div>
  );
}

export default LocationAutocomplete;
